import React from 'react';

const Alert = props => (
    <div className={`alert alert-${props.ErrMode} ${props.Show ? '' : 'hide'}`}>
        <span dangerouslySetInnerHTML={{ __html: props.Content }} />
    </div>
);
export default Alert;
